import React from 'react';
import Image from '@components/Image';
import { graphql } from 'gatsby';
import Carousel, { Modal, ModalGateway } from 'react-images';
import * as c from '@identity/constants';
import { Content } from '@identity/wrappers';
import { Grid, GridImageWrapper, Title } from './styles';
import TypeScale from '@identity/type';
import { Wrapper } from '../Blog/styles';

type State = {
  selectedIndex?: number,
  lightboxIsOpen: boolean,
};

export default class Home extends React.Component<State> {
  state = {
    selectedIndex: 0,
    lightboxIsOpen: false,
  };

  toggleLightbox = (selectedIndex: number) => {
    this.setState(state => ({
      lightboxIsOpen: !state.lightboxIsOpen,
      selectedIndex,
    }));
  };

  render() {
    const { data } = this.props;
    const images = data && data.contentfulPhotoGallery.gallery;
    const imageArray = images && images.map(({ file }) => ({ src: file.url }));
    const { selectedIndex, lightboxIsOpen } = this.state;

    return (
      <Content>
        <Wrapper space={{ margin: 'top-md' }}>
          <Title>
            <TypeScale.H1
              spacing={{ padding: 'top-lg' }}
              alignText="center"
              color={c.colors.PRIMARY_004}
            >
              {data.contentfulPhotoGallery.title}
            </TypeScale.H1>
          </Title>
          <Grid>
            {images &&
              images.map(({ file }, j) => (
                <GridImageWrapper onClick={() => this.toggleLightbox(j)}>
                  <Image src={file.url} absolute />
                </GridImageWrapper>
              ))}
          </Grid>
          <ModalGateway closeOnBackdropClick>
            {lightboxIsOpen ? (
              <Modal
                closeOnBackdropClick
                onClose={this.toggleLightbox}
                styles={{
                  blanket: base => ({
                    ...base,
                    backgroundColor: 'rgba(254, 248, 248, 0.85)',
                  }),
                  dialog: base => ({
                    ...base,
                    maxWidth: '100%',
                  }),
                }}
              >
                <Carousel
                  currentIndex={selectedIndex}
                  views={imageArray}
                  styles={{
                    footer: base => ({
                      ...base,
                      background: 'none !important',
                      color: '#666',
                      padding: 20,

                      position: 'static',

                      '& a': {
                        color: 'black',
                      },
                    }),
                    header: base => ({
                      ...base,
                      background: 'none !important',
                      padding: 10,
                      top: 100,
                      position: 'static',
                    }),
                    headerClose: base => ({
                      ...base,
                      color: '#666',

                      ':hover': { color: '#a6302f' },
                    }),
                    headerFullscreen: base => ({
                      ...base,
                      color: '#666',

                      ':hover': { color: '#a6302f' },
                    }),
                    view: base => ({
                      ...base,
                      maxHeight: 1200,
                      overflow: 'hidden',
                    }),
                    navigationNext: base => ({
                      ...base,
                      backgroundColor: '#a6302f',

                      ':hover': {
                        backgroundColor: '#E04B67',
                      },
                      ':active': {
                        backgroundColor: '#E04B67',
                        transform: 'translateY(2px)',
                      },
                    }),
                    navigationPrev: base => ({
                      ...base,
                      backgroundColor: '#a6302f',

                      ':hover': {
                        backgroundColor: '#E04B67',
                      },
                      ':active': {
                        backgroundColor: '#E04B67',
                        transform: 'translateY(2px)',
                      },
                    }),
                  }}
                />
              </Modal>
            ) : null}
          </ModalGateway>
        </Wrapper>
      </Content>
    );
  }
}

export const query = graphql`
  query($slug: String!) {
    contentfulPhotoGallery(slug: { eq: $slug }) {
      slug
      title
      description {
        description
      }
      gallery {
        file {
          url
        }
      }
    }
  }
`;
